import { RegistrationPartsWarranty } from '../../models/config/registration-parts-warranty.interface';

export const mockRegistrationPartsWarranty: RegistrationPartsWarranty = {
  partsWarrantyInMonths: 12,
  excludedApplianceCodes: [],
};
